import { useUser } from "../context/UserProvider";
import apiClient from "../utils/axiosUtil";

export const useAuth = () => {
  const { login } = useUser();

  const authenticateUser = async (user) => {
    try {
      return await apiClient.post("/auth/login", user);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchUser = async () => {
    try {
      const response = await apiClient.get("/users/getUser");
      login(response.data);  // This now works because it's inside a hook
    } catch (error) {
      console.error("Failed to fetch user", error);
    }
  };

  const validateToken = async () => {
    try {
      const response = await apiClient.get("/users/validateToken");
      return response.status === 200;
    } catch (error) {
      return false;
    }
  };

  const logOut = async() => {
    try {
      await apiClient.post("/auth/logout");
      login(null);
      window.location.href = "/dashboard"; // Redirect to dashboard after logout
    } catch (error) {
      console.error("Failed to log out", error);
    }
  }

  return { authenticateUser, fetchUser, validateToken, logOut };
};